import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import { Form, Input } from 'antd';
import { Button, SubmitButton } from '@quyva/shared-ui';
import { useRepoSubmit } from '../hooks/useRepoSubmit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleXmark,
    faExclamationTriangle,
    faFolderPlus,
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { validateRepoName } from '@quyva/common';
import { ProcessType } from '@quyva/common';
import { TaskProgressType } from '@quyva/common';
import { getUrl } from './pdfDisplay/utils';

const Addnewrepo_postgres = (props) => {
    const reponame = props.reponame;
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        hostname: '',
        port: '',
        database: '',
        user: '',
        password: '',
    });
    const { isSubmitting, runSubmit, WarningModal } = useRepoSubmit(
        'database repository creation'
    );
    const active_user = JSON.parse(localStorage.getItem('current'));

    // From the parent, which owns the repo list. Absent is safe: the collision check is
    // skipped and `props.error` still gates submission.
    const isNameFound = props.isNameFound;

    const { hostname, port, database, user, password } = formData;

    const onFinish = async (values) => {
        setError('');
        const dataToSend = new FormData();
        dataToSend.append('hostname', hostname);
        dataToSend.append('port', port);
        dataToSend.append('database', database);
        dataToSend.append('user', user);
        dataToSend.append('password', password);
        dataToSend.append('reponame', reponame);
        dataToSend.append('email', active_user.email);
        dataToSend.append('repotype', 'postgress');

        const nameCheck = validateRepoName(reponame, isNameFound);
        if (!nameCheck.valid) {
            setError(nameCheck.error);
            return;
        }

        runSubmit(async () => {
        const status = {
            message: 'Starting db repository creation',
            percentageCompletion: 0,
            process: ProcessType.REPO_CREATION,
            progress: TaskProgressType.STARTED,
            repoId: null,
            repoName: reponame,
            statusCode: 200,
            timeStamp: new Date(),
            userMail: active_user.email,
        };
        props.socket.emit('statusUpdate', status);
        const tempUrl = getUrl(
            `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/addpostgressrepo`
        );
        // Send data to server
        axios
            .post(tempUrl, dataToSend, {
                onUploadProgress: (progressEvent) => {
                    const status = {
                        message: 'Uploading files for repository creation',
                        percentageCompletion: 20,
                        process: ProcessType.REPO_CREATION,
                        progress: TaskProgressType.PROCESSING,
                        repoId: null,
                        repoName: reponame,
                        statusCode: 200,
                        timeStamp: new Date(),
                        userMail: active_user.email,
                    };

                    props.socket.emit('statusUpdate', status);
                },
            })
            .then(async (response) => {
                console.log('Server response:', response.data);
                await props.getAllReposData();
                props.setAddNewMode(false); // Assuming you want to disable add new mode on success
            })
            .catch((error) => {
                console.error('Error:', error);
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.detail
                ) {
                    console.log(error.response.data.detail); // Alert the error detail
                } else {
                    alert('An unexpected error occurred');
                }
            });

        props.setAddNewMode(false);
        }); // end runSubmit callback
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const onCancelClick = () => {
        console.log('cancel clicked');
        // You can add further actions here
    };

    // props.error included so the parent's name validation gates this tab too.
    const isFormComplete = () => {
        return (
            Object.values(formData).every((value) => value.trim() !== '') &&
            reponame &&
            !props.error &&
            !error
        );
    };

    return (
        <div>
            <Form
                name='basic'
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                layout='vertical'
            >
                <div className='grid grid-cols-3 gap-4'>
                    <div className='col-span-3 sm:col-span-3 md:col-span-2 lg:col-span-2'>
                        <Form.Item
                            label='Hostname'
                            name='hostname'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the hostname!',
                                },
                            ]}
                        >
                            <Input
                                name='hostname'
                                value={hostname}
                                onChange={handleChange}
                            />
                        </Form.Item>
                    </div>
                    <div className='col-span-3 sm:col-span-3 md:col-span-1 lg:col-span-1'>
                        <Form.Item
                            label='Port'
                            name='port'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the port!',
                                },
                            ]}
                        >
                            <Input
                                name='port'
                                value={port}
                                onChange={handleChange}
                            />
                        </Form.Item>
                    </div>
                </div>

                <Form.Item
                    label='Database'
                    name='database'
                    rules={[
                        {
                            required: true,
                            message: 'Please input the database!',
                        },
                    ]}
                >
                    <Input
                        name='database'
                        value={database}
                        onChange={handleChange}
                    />
                </Form.Item>

                <Form.Item
                    label='User'
                    name='user'
                    rules={[
                        {
                            required: true,
                            message: 'Please input the user!',
                        },
                    ]}
                >
                    <Input name='user' value={user} onChange={handleChange} />
                </Form.Item>

                <Form.Item
                    label='Password'
                    name='password'
                    rules={[
                        {
                            required: true,
                            message: 'Please input the password!',
                        },
                    ]}
                >
                    <Input.Password
                        name='password'
                        value={password}
                        onChange={handleChange}
                    />
                </Form.Item>
                {error && (
                    <div className='flex justify-center items-center text-buttons-alert400 mt-3'>
                        <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            className='mr-2'
                        />
                        {error}
                    </div>
                )}

                <Form.Item>
                    <div className='flex items-center justify-center mt-4'>
                        <div className='flex items-center justify-between w-full'>
                            <Button
                                type='danger'
                                icon={faCircleXmark}
                                text={'Cancel'}
                                tile={'Cancel and close the modal'}
                                className='w-1/3'
                                onClick={() => {
                                    props.setAddNewMode(false);
                                }}
                            />

                            <SubmitButton
                                icon={faFolderPlus}
                                text='Add'
                                submittingText='Creating...'
                                isSubmitting={isSubmitting}
                                disabled={!isFormComplete()}
                                title='Upload files and add new repository'
                            />
                        </div>
                    </div>
                </Form.Item>
            </Form>
        {WarningModal}
        </div>
    );
};

export default Addnewrepo_postgres;
